import { useCallback } from "react"

import { JOB_ADS_STATE_VALUE } from "@/modules/jobAds/client/api/constants"
import { useGetJobAdsState } from "@/modules/jobAds/client/hooks/useGetJobAdsState"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"
import { isJobAdSavedOrAppliedState } from "@/modules/jobAds/client/utils/isJobAdSavedOrAppliedState"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

type JobAdStateType = {
  jobAdCanBeLiked: boolean
  jobAdIsLiked: boolean
}

export const useJobAdState = (jobAdId: string): JobAdStateType => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = !!dataCurrentUser?.isLogged

  const { dataJobAds } = useJobAdsFromAlgolia()
  const jobAdsIds = dataJobAds?.jobAds.map(jobAd => jobAd.id) || []

  const { jobAdsState, isSuccessJobAdsState } = useGetJobAdsState(jobAdsIds)

  const isJobAdSavedOrAppliedStateCallback = useCallback(isJobAdSavedOrAppliedState, [jobAdsState])

  const jobAdCanBeLiked =
    isLogged &&
    isSuccessJobAdsState &&
    !isJobAdSavedOrAppliedStateCallback({
      id: jobAdId,
      jobAdsState: jobAdsState || [],
      state: JOB_ADS_STATE_VALUE.APPLIED,
    })
  const jobAdIsLiked = isJobAdSavedOrAppliedStateCallback({
    id: jobAdId,
    jobAdsState: jobAdsState || [],
    state: JOB_ADS_STATE_VALUE.SAVED,
  })

  return {
    jobAdCanBeLiked,
    jobAdIsLiked,
  }
}
